import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { Container, Button, Row, Col, Form } from "react-bootstrap";
import { get } from "lodash";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import { ERROR_MSG, PATHS, STATUS } from "../../constant";
import {
  createProjectAction,
  editProjectAction
} from "../../actions/createProject.action";
import { changeProjectStatus } from "../../actions/projectDetail.action";
import { clearProjectDataAction } from "../../actions/formData.action";
import {
  modifyDataForPost,
  PROJECT_CLASSIFICATION,
  PROJECT_STATUS
} from "./helper";
import {
  dateFormat,
  isValidArray,
  formatNumber,
  formatNumberOnDashBoard,
  transformProjectCategoryId,
  Project_Stage_Helper,
  GROUP_KEYS,
  getLocalstorage
} from "../../helper";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { LoaderPage } from "../../component/Loader";
import PreviewMilestone from "./Milestones/PreviewMilestone";
import ModalVerifyIIGProject from "./ModalVerifyIIGProject";
import { successToastStyle, errorToastStyle } from "../../customToast";

class ProjectPreview extends Component {
  state = {
    previewData: {}
  };

  componentDidMount() {
    const { previewData, pageDetail, history } = this.props;
    if (!previewData) {
      history.push(PATHS.DASHBOARD);
    }
    if (
      previewData &&
      !(
        Object.keys(previewData).length === 0 &&
        previewData.constructor === Object
      )
    ) {
      let matchingResults = previewData.groupCategoryList.filter(function(
        data
      ) {
        return data.id === parseInt(previewData.groupId);
      });
      const sponsoring =
        (matchingResults[0] && matchingResults[0].name) || null;

      let departmentResults = previewData.districtList.filter(function(data) {
        return data.id == parseInt(previewData.sponsoringDepartmentId);
      });
      const department =
        (departmentResults[0] && departmentResults[0].name) || null;

      let districtResults = previewData.districtList.filter(function(data) {
        return data.id == parseInt(previewData.district);
      });
      const district = (districtResults[0] && districtResults[0].name) || null;

      let sectorResult = pageDetail.sector.filter(function(data) {
        return data.id === parseInt(previewData.sectorId);
      });
      const sector = (sectorResult[0] && sectorResult[0].name) || null;

      let subSectorResult = previewData.subSectorList.filter(function(data) {
        return data.id === parseInt(previewData.subSectorId);
      });
      const subSector = (subSectorResult[0] && subSectorResult[0].name) || null;

      let schemes = previewData.schemesList.filter(function(data) {
        return data.id === parseInt(previewData.schemeId);
      });
      const scheme = (schemes[0] && schemes[0].name) || null;
      this.setState({
        previewData: previewData,
        sponsoring: sponsoring,
        subSector: subSector,
        sector: sector,
        scheme: scheme,
        district: district,
        department: department
      });
    }
  }

  handlePrint = () => {
    window.print();
  };

  onSubmit = async () => {
    const {
      createProjectDispatch,
      history,
      clearProjectDataDispatch
    } = this.props;
    const { previewData } = this.state;
    this.setState(
      {
        isProjectSubmitting: true
      },
      async () => {
        if (previewData) {
          const dataForPost = modifyDataForPost(previewData);
          dataForPost.projectStatus = PROJECT_STATUS.UV;
          if (get(previewData, "id")) {
            dataForPost.projectId = get(previewData, "id");
          }
          const response = await createProjectDispatch(undefined, dataForPost);
          this.setState({ isProjectSubmitting: false });
          if (response) {
            const { message, status } = response;
            if (status) {
              toast.success(
                <p className="toast-text-alignment">{message}</p>,
                successToastStyle
              );
              // setLocalstorage("projectResponse", response || null);
              clearProjectDataDispatch();
              history.push({
                pathname: PATHS.SUCCESS,
                state: { projectId: get(response, "data.projectId"), message }
              });
            } else {
              toast.error(
                <p className="toast-text-alignment">{message}</p>,
                errorToastStyle
              );
            }
          } else {
            toast.error(
              <p className="toast-text-alignment">
                {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
              </p>,
              errorToastStyle
            );
          }
        }
      }
    );
  };

  onEdit = async showToast => {
    const {
      editProjectDispatch,
      history,
      clearProjectDataDispatch
    } = this.props;
    const { previewData } = this.state;
    if (previewData) {
      const isIIGDraft = this.state.previewData.status === "CRIP_DRAFT";
      const dataForPost = modifyDataForPost(previewData);
      dataForPost.projectStatus = previewData.status;
      dataForPost.projectId = isIIGDraft
        ? previewData.projectId
        : previewData.id;
      this.setState({
        isProjectSubmitting: STATUS.LOADING
      });

      // edit project
      const response = await editProjectDispatch(undefined, dataForPost);
      if (response) {
        const { message, status } = response;
        if (status) {
          if (showToast) {
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            );
          }
          if (!isIIGDraft) {
            clearProjectDataDispatch();
            history.push({
              pathname: PATHS.SUCCESS,
              state: { projectId: get(previewData, "id"), message }
            });
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {message || ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
      this.setState({
        isProjectSubmitting: STATUS.SUCCESS
      });
    }
  };

  openConfirmationAlert = projectStatus => {
    this.setState(prevState => ({
      projectStatus,
      showAlert: !prevState.showAlert
    }));
  };

  verifyIIGDraft = async (attachmentFiles = []) => {
    let {
      previewData: { comment }
    } = this.state;
    const response = await changeProjectStatus(undefined, {
      comment: comment,
      projectId: get(this.state.previewData, "projectId"),
      projectStatus: "VERIFIED",
      files: attachmentFiles,
      terminatedDate: null
    });
    if (response) {
      const { data, status } = response;
      if (status) {
        this.setState({
          projectStatus: "VERIFIED"
        });
      } else {
        toast.error(
          <p className="toast-text-alignment">{data.message}</p>,
          errorToastStyle
        );
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };
  onClickOfVerifyButton = async (attachmentFiles = []) => {
    const { history } = this.props;
    const {
      previewData: { comment }
    } = this.state;
    if (comment === "") {
      this.handleCommentValidation(true);
    } else {
      this.handleCommentValidation(false);
      await this.onEdit(false);
      await this.verifyIIGDraft(attachmentFiles);
      toast.success(
        <p className="toast-text-alignment">Project submitted successfully!</p>,
        successToastStyle
      );
      this.setState(
        {
          dataUnsaved: false
        },
        () => {
          history.push({
            pathname: PATHS.PROJECT_LIST
          });
        }
      );
    }
  };
  handleCommentValidation = isInvalid => {
    const { error } = this.state;
    this.setState({
      error: {
        ...error,
        comment: {
          error: isInvalid,
          message: isInvalid ? "Comment is required" : null
        }
      }
    });
  };
  commentValueChange = value => {
    this.setState({
      previewData: { ...this.state.previewData, comment: value }
    });
  };

  loadModalForVerifiedAction = () => {
    let {
      previewData: { comment },
      error,
      showModalForVerifyingProject,
      previewData
    } = this.state;
    return (
      <ModalVerifyIIGProject
        show={showModalForVerifyingProject}
        onHide={() => {
          this.setState({
            showModalForVerifyingProject: false
          });
        }}
        comment={comment}
        onCommentChange={this.commentValueChange}
        onVerify={this.onClickOfVerifyButton}
        error={error}
        createdDate={previewData.createdDate}
      />
    );
  };

  getDropDownName(array, targetId) {
    const foundObject = array.find(item => item.id == targetId);
    const foundObject1 = array.find(item => item.id === targetId);
    //console.log(foundObject);
    //console.log(foundObject1);
    if (foundObject) {
      return foundObject.name;
    } else {
      return "NA";
    }
  }
  convertString(inputString) {
    // Split the string by underscores
    const words = inputString.split("_");

    // Convert each word to title case and join them with spaces
    const convertedString = words
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");

    return convertedString;
  }
  render() {
    const {
      previewData,
      sponsoring,
      subSector,
      sector,
      scheme,
      isProjectSubmitting,
      showAlert,
      showIIGProjectAlert,
      district,
      department
    } = this.state;
    const {
      pageDetail,
      issuesCategoryList,
      history: {
        location: { isEdit }
      }
    } = this.props;
    const { issuesProps } = previewData;
    const isIIGDraft = previewData.status === "CRIP_DRAFT";
    const iigPayload = get(previewData, "iigPayload");
    const allStates = get(pageDetail, "state", []);
    const locations = get(previewData, "locations", []);
    let locationsData = [];
    for (let i = 0; i < allStates.length; i++) {
      for (let j = 0; j < locations.length; j++) {
        if (parseInt(locations[j].id) === parseInt(allStates[i].id)) {
          let loc = { ...locations[j] };
          loc.name = allStates[i].name;
          locationsData.push(loc);
        }
      }
    }

    //let bankCount = get(previewData, "projectBankInfoBanks", []).length;
    let otherBankName = get(previewData, "otherBankName");
    let banks = get(previewData, "projectBankInfoBanks", []);
    let countingBanks = banks.filter(item => {
      if (item.id !== 51) {
        return item;
      } else if (
        item.id === 51 &&
        (otherBankName !== "" && otherBankName !== undefined)
      ) {
        return item;
      }
    });
    const userInfo = getLocalstorage("user");
    const isUserPP = userInfo.groupCategory === "PP";
    const isUserDISTRICT = userInfo.groupCategory === "DISTRICT";
    const isUserSTATE = userInfo.groupCategory === "STATE";

    const targetDate = previewData.createdDate;
    const dateAfterCrip = new Date("2026-07-08").getTime();

    return (
      <div className="submission-wrapper">
        <LoaderPage loading={isProjectSubmitting} />
        <ConfirmationComponent
          show={showAlert}
          isLoading={isProjectSubmitting}
          modalClass={"confirmation-modal"}
          saveHandler={isEdit ? this.onEdit : this.onSubmit}
          closeHandler={this.openConfirmationAlert}
        />
        {/*<ComponentLoader isLoading={isProjectSubmitting === STATUS.LOADING} />*/}
        <div className="submission-banner-wrapper">
          <div className="submission-banner-inner">
            <Container>
              <h1 className="page-heading">Article Preview</h1>
              <div className="button-group">
                {/* <Button className="btn-white-invert btn-small print-btn">
                  <div className="download-icon white" />
                  Download
                </Button> */}
                <Button
                  className="btn-white-invert btn-small"
                  onClick={this.handlePrint}
                >
                  <div className="print-icon white" />
                  Print
                </Button>
              </div>
            </Container>
          </div>
        </div>
        <Container className="project-info-container">
          <h2>Project Information</h2>
          {previewData.projectCategoryId ? (
            <div>
              <div className="project-info">
                {get(previewData, "projectCategoryId", null) && (
                  <Row>
                    <Col lg={5}>Project Awarded by</Col>
                    <Col lg={7}>
                      {get(previewData, "projectCategoryId", null)}
                    </Col>
                  </Row>
                )}
                {get(previewData, "projectCategoryId", null) === "CENTRAL" && (
                  <Row>
                    <Col lg={5}>Sponsoring Ministry</Col>
                    <Col lg={7}>{sponsoring}</Col>
                  </Row>
                )}
                {get(previewData, "projectCategoryId", null) === "CENTRAL" &&
                department ? (
                  <Row>
                    <Col lg={5}>Sponsoring Department</Col>
                    <Col lg={7}>{department}</Col>
                  </Row>
                ) : null}
                {get(previewData, "projectCategoryId", null) === "STATE" && (
                  <Row>
                    <Col lg={5}>Sponsoring State</Col>
                    <Col lg={7}>{sponsoring}</Col>
                  </Row>
                )}
                {get(previewData, "projectCategoryId", null) === "STATE" && (
                  <Row>
                    <Col lg={5}>
                      {sponsoring == "Arunachal Pradesh"
                        ? "Beneficiary Department"
                        : "Sponsoring Department"}
                    </Col>
                    <Col lg={7}>
                      {previewData.sponsoringDeptARdata.length
                        ? this.getDropDownName(
                            previewData.sponsoringDeptARdata,
                            previewData.sponsoringDepartmentId
                          )
                        : department}
                    </Col>
                  </Row>
                )}
                {get(previewData, "district", null) && (
                  <Row>
                    <Col lg={5}>District/Department</Col>
                    <Col lg={7}>{district}</Col>
                  </Row>
                )}
                {get(previewData, "name", null) && (
                  <Row>
                    <Col lg={5}>
                      {get(previewData, "projectNameTitle", "Project Name")}
                    </Col>
                    <Col lg={7}>
                      <span
                        className={`${
                          /[\u0900-\u097F]/.test(get(previewData, "name"))
                            ? "hindi-text-wrap line-height-preview"
                            : ""
                        }`}
                      >
                        {get(previewData, "name", null)}
                      </span>
                    </Col>
                  </Row>
                )}
                {get(previewData, "description", null) && (
                  <Row>
                    <Col lg={5}>Brief Project Description</Col>
                    <Col lg={7}>
                      <span
                        className={`${
                          /[\u0900-\u097F]/.test(get(previewData, "name"))
                            ? "hindi-text-wrap line-height-preview"
                            : ""
                        }`}
                      >
                        {get(previewData, "description", null)}
                      </span>
                    </Col>
                  </Row>
                )}
                {get(previewData, "cin", null) && (
                  <Row>
                    <Col lg={5}>CIN Number</Col>
                    <Col lg={7}>{get(previewData, "cin", null)}</Col>
                  </Row>
                )}
                {sector && (
                  <Row>
                    <Col lg={5}>Project Sector</Col>
                    <Col lg={7}>{sector}</Col>
                  </Row>
                )}
                {subSector && (
                  <Row>
                    <Col lg={5}>Project Sub Sector</Col>
                    <Col lg={7}>{subSector}</Col>
                  </Row>
                )}
                {scheme && (
                  <Row>
                    <Col lg={5}>Project Schemes</Col>
                    <Col lg={7}>{scheme}</Col>
                  </Row>
                )}
                {(get(previewData, "cost", null) && (
                  <Row>
                    <Col lg={5}>Project Cost (in crores)</Col>
                    <Col lg={7}>
                      &#8377;{" "}
                      {formatNumber(
                        get(previewData, "revisedCost", null) ||
                          get(previewData, "cost", 0)
                      )}{" "}
                      Cr.
                    </Col>
                  </Row>
                )) ||
                  null}
                {(get(previewData, "fundReleaseCost", null) && (
                  <Row>
                    <Col lg={5}>
                      Funds released to the Executing Agency (in crores)
                    </Col>
                    <Col lg={7}>
                      &#8377;{" "}
                      {formatNumber(
                        get(previewData, "fundReleaseCost", null) ||
                          get(previewData, "fundReleaseCost", 0)
                      )}{" "}
                      Cr.
                    </Col>
                  </Row>
                )) ||
                  null}
                {get(previewData, "defaultSelected", null) && (
                  <Row
                    style={{
                      display:
                        isUserPP || isUserDISTRICT || isUserSTATE
                          ? "none"
                          : null
                    }}
                  >
                    <Col lg={5}>Proponent</Col>
                    <Col lg={7}>
                      {get(previewData, "defaultSelected", null)}
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col lg={5}>Locations</Col>
                  <Col lg={7} className="add-scroll">
                    {(isValidArray(locationsData) &&
                      locationsData.map(loc => {
                        return (
                          <div>
                            <span>{loc.name}</span>
                            {(loc.districtIdName &&
                              loc.districtIdName.length &&
                              ` - ${
                                loc.districtIdName.length === 1
                                  ? `District`
                                  : "Districts"
                              }:
                                  ${loc.districtIdName.map(
                                    item => item.name
                                  )}`) ||
                              null}
                            {(loc.circleIdName &&
                              loc.circleIdName.length &&
                              ` - ${
                                loc.circleIdName.length === 1
                                  ? `Circle`
                                  : "Circles"
                              }:
                                  ${loc.circleIdName.map(
                                    item => item.name
                                  )}`) ||
                              null}
                            {loc.cost
                              ? " -  Cost(Cr): " +
                                formatNumberOnDashBoard(loc.cost)
                              : null}
                            {loc.distance
                              ? " - Distance(Km): " + formatNumber(loc.distance)
                              : null}
                          </div>
                        );
                      })) ||
                      null}
                  </Col>
                </Row>
                {get(previewData, "executingAgency", null) && (
                  <Row>
                    <Col lg={5}>Executing Agency Name</Col>
                    <Col lg={7}>
                      {get(previewData, "executingAgency", null) || null}
                    </Col>
                  </Row>
                )}
                {get(previewData, "implementationMode", null) && (
                  <Row>
                    <Col lg={5}>Implementation Mode</Col>
                    <Col lg={7}>
                      {get(previewData, "implementationMode", null) || null}
                    </Col>
                  </Row>
                )}
                {get(previewData, "pli") && (
                  <Row>
                    <Col lg={5}>PLI</Col>
                    <Col lg={7}>
                      {(get(previewData, "pli") === true && "Yes") || "No"}
                    </Col>
                  </Row>
                )}

                {(get(previewData, "centralCost", null) && (
                  <Row>
                    <Col lg={5}>Project Cost Share (in crores)</Col>
                    <Col lg={7}>
                      <span>Central Share</span> &#8377;{" "}
                      {formatNumber(
                        get(previewData, "centralCost", null) ||
                          get(previewData, "centralCost", 0)
                      )}{" "}
                      Cr.{" "}
                      <span style={{ paddingLeft: "1em" }}>State Share</span>{" "}
                      &#8377;{" "}
                      {formatNumber(
                        get(previewData, "stateCost", null) ||
                          get(previewData, "stateCost", 0)
                      )}{" "}
                      Cr.
                    </Col>
                  </Row>
                )) ||
                  null}
                <Row
                  style={{
                    display: sponsoring == "Arunachal Pradesh" ? "none" : null
                  }}
                >
                  <Col lg={5}>Banks</Col>
                  <Col lg={7}>
                    {isValidArray(countingBanks)
                      ? (countingBanks || []).map((bank, index) => {
                          let separator =
                            index < countingBanks.length - 1 ? "," : null;
                          if (bank.id === 51) {
                            return (
                              <span key={index}>
                                {get(previewData, "otherBankName", null)}
                                {separator}&nbsp;
                              </span>
                            );
                          } else {
                            return (
                              <span key={index}>
                                {get(bank, "name", null)}
                                {separator} &nbsp;
                              </span>
                            );
                          }
                        })
                      : "NA"}
                  </Col>
                </Row>
                {previewData.schemeForAr == null ||
                previewData.schemeForAr == "" ? null : (
                  <>
                    <Row>
                      <Col lg={5}>Project Scheme</Col>
                      <Col lg={7}>{previewData.schemeForAr}</Col>
                    </Row>
                  </>
                )}
                {previewData.sponsoringAgencyList.length == 0 ? null : (
                  <>
                    <Row>
                      <Col lg={5}>Sponsoring Agency</Col>
                      <Col lg={7}>
                        {this.getDropDownName(
                          previewData.sponsoringAgencyList,
                          previewData.sponsoringAgency
                        )}
                      </Col>
                    </Row>
                  </>
                )}
                {get(previewData, "projectBankInfoExpectedDate") && (
                  <Row>
                    <Col lg={5}>Date of Financial Closure Expected</Col>
                    <Col lg={7}>
                      {dateFormat(
                        get(previewData, "projectBankInfoExpectedDate")
                      )}
                    </Col>
                  </Row>
                )}
                {get(previewData, "projectBankInfoActualDate") && (
                  <Row>
                    <Col lg={5}>Date of Financial Closure Actual</Col>
                    <Col lg={7}>
                      {dateFormat(
                        get(previewData, "projectBankInfoActualDate")
                      )}
                    </Col>
                  </Row>
                )}
                {get(
                  previewData,
                  "projectImplementationClassification",
                  null
                ) && (
                  <Row>
                    <Col lg={5}>Project Classification</Col>
                    <Col lg={7}>
                      {
                        PROJECT_CLASSIFICATION[
                          get(
                            previewData,
                            "projectImplementationClassification",
                            null
                          )
                        ]
                      }
                    </Col>
                  </Row>
                )}
                {get(previewData, "projectImplementationStartState", null) && (
                  <Row>
                    <Col lg={5}>Implementation Started</Col>
                    <Col lg={7}>
                      {this.convertString(
                        previewData.projectImplementationStartState
                      )}
                    </Col>
                  </Row>
                )}
                {/* {(get(previewData, "targetCompletionDate", null) && (
                  <Row>
                    <Col lg={5}>Target Date Of Completion</Col>
                    <Col lg={7}>
                      {dateFormat(
                        get(previewData, "targetCompletionDate", null)
                      )}
                    </Col>
                  </Row>
                )) ||
                  null} */}
                {get(previewData, "projectCompletionDTO.status") && (
                  <Row>
                    <Col lg={5}>Project Status</Col>
                    <Col lg={7}>
                      <div>
                        {get(previewData, "projectCompletionDTO.status") !==
                        "NO IMPLEMENTATION"
                          ? Project_Stage_Helper(
                              get(previewData, "projectCompletionDTO.status")
                            )
                          : ""}
                      </div>
                      <div>
                        {get(previewData, "projectCompletionDTO.date") ? (
                          <div>
                            Date -{" "}
                            {dateFormat(
                              get(previewData, "projectCompletionDTO.date")
                            )}
                          </div>
                        ) : null}
                        {get(
                          previewData,
                          "projectCompletionDTO.physicalProgressAsOf"
                        ) ? (
                          <div>
                            Physical Progress As of -{" "}
                            {dateFormat(
                              get(
                                previewData,
                                "projectCompletionDTO.physicalProgressAsOf"
                              )
                            )}
                          </div>
                        ) : null}
                        {get(previewData, "projectCompletionDTO.percentage") ? (
                          <div>
                            Physical Progress -{" "}
                            {get(
                              previewData,
                              "projectCompletionDTO.percentage"
                            )}
                            %
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                )}

                {isIIGDraft && (
                  <Row>
                    <Col lg={5}>
                      {targetDate >= dateAfterCrip ? "CRIP" : "IIG"} Project
                      Status
                    </Col>
                    <Col lg={7}>{previewData.iigProjectStatus}</Col>
                  </Row>
                )}

                {previewData && previewData.projectImplementationStartDate && (
                  <Row>
                    <Col lg={5}>Implementation Start Date</Col>
                    <Col lg={7}>
                      {dateFormat(previewData.projectImplementationStartDate)}
                    </Col>
                  </Row>
                )}
                {get(previewData, "projectImplementationAnticipatedDate") && (
                  <Row>
                    <Col lg={5}>Original Date Of Completion</Col>
                    <Col lg={7}>
                      {dateFormat(
                        previewData.projectImplementationAnticipatedDate
                      )}
                    </Col>
                  </Row>
                )}
                {previewData && previewData.revisedTargetCompletionDate && (
                  <Row>
                    <Col lg={5}>Revised Target Date of Completion</Col>
                    <Col lg={7}>
                      {dateFormat(previewData.revisedTargetCompletionDate)}
                    </Col>
                  </Row>
                )}
                {get(
                  previewData,
                  "projectImplementationDirectEmployment",
                  null
                ) ? (
                  <Row>
                    <Col lg={5}>Anticipated Employment Generation</Col>
                    <Col lg={7}>
                      {get(
                        previewData,
                        "projectImplementationDirectEmployment",
                        null
                      )}
                      ,&nbsp;&nbsp;
                      {get(
                        previewData,
                        "projectImplementationInDirectEmployment",
                        null
                      )}
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  <Col lg={5}>Supporting Documents</Col>
                  <Col lg={7}>
                    <div className="attachment-added success-file">
                      {isValidArray(get(previewData, "files"))
                        ? get(previewData, "files", []).map(file => {
                            const extension = file.name.substr(
                              file.name.lastIndexOf(".") + 1,
                              file.name.length
                            );
                            const name = file.name.substr(
                              0,
                              file.name.lastIndexOf(".") - 1
                            );
                            return (
                              <div className="project-download-icons">
                                <div className="download-icons-pdf">
                                  {extension}
                                </div>
                                <a
                                  href={file.s3Url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {file.title || name}
                                </a>
                              </div>
                            );
                          })
                        : "NA"}
                    </div>
                  </Col>
                </Row>
                {isIIGDraft && (
                  <>
                    <Row>
                      <Col lg={5}>User ID</Col>
                      <Col lg={7}>{iigPayload.userMeta.userID}</Col>
                    </Row>
                    <Row>
                      <Col lg={5}>User Name</Col>
                      <Col lg={7}>{iigPayload.userMeta.userName}</Col>
                    </Row>
                    <Row>
                      <Col lg={5}>Contact Details</Col>
                      <Col lg={7}>{iigPayload.userMeta.phone}</Col>
                    </Row>
                    <Row>
                      <Col lg={5}>Designation</Col>
                      <Col lg={7}>{iigPayload.userMeta.designation}</Col>
                    </Row>
                    <Row>
                      <Col lg={5}>Organization</Col>
                      <Col lg={7}>{iigPayload.userMeta.organization}</Col>
                    </Row>
                  </>
                )}
              </div>

              {!isIIGDraft && (
                <PreviewMilestone
                  bucketMilestoneCOS={get(
                    previewData,
                    "bucketMilestoneCOS",
                    []
                  ).filter(item => item.bucketName !== "Cabinet Milestone")}
                  cabinetMilestone={get(
                    previewData,
                    "bucketMilestoneCOS",
                    []
                  ).find(item => item.bucketName === "Cabinet Milestone")}
                />
              )}

              <div className="issues-info-container">
                {isValidArray(get(previewData, "issueCOList")) &&
                get(previewData, "issueCOList")[0] &&
                get(previewData, "issueCOList")[0].title ? (
                  <h2>Issue(s) Information</h2>
                ) : null}
                {isValidArray(get(previewData, "issueCOList"))
                  ? get(previewData, "issueCOList", []).map(
                      (issueCOList, index) => {
                        const district =
                          get(issuesProps, "districtList") &&
                          (issuesProps.districtList[index] || []).find(
                            value =>
                              value.id == issueCOList.stateDistrictAndDepartment
                          );
                        const list =
                          (issueCOList.groupCategory === GROUP_KEYS.CENTRAL &&
                            get(issuesProps, "CENTRAL")) ||
                          (issueCOList.groupCategory === GROUP_KEYS.STATE &&
                            get(issuesProps, "STATE")) ||
                          (issueCOList.groupCategory ===
                            GROUP_KEYS.STATE_DEPARTMENT &&
                            get(issuesProps, "STATE_DEPARTMENT")) ||
                          (issueCOList.groupCategory === GROUP_KEYS.DISTRICT &&
                            get(issuesProps, "DISTRICT")) ||
                          [];
                        const recepint =
                          Array.isArray(list) &&
                          list.find(
                            value => value.id == issueCOList.recipientGroupId
                          );

                        const issueCategoryObj =
                          Array.isArray(issuesCategoryList) &&
                          issuesCategoryList.find(
                            item => item.id === +issueCOList.issueCategoryId
                          );

                        return get(issueCOList, "title", null) ? (
                          <div className="issues-info" key={index}>
                            <h2 className="issue-category">
                              {get(issueCOList, "title", null)}
                            </h2>
                            <p className="issue-place">
                              Recipient{" "}
                              {transformProjectCategoryId(
                                get(issueCOList, "groupCategory", null)
                              )}{" "}
                              -{" "}
                              <span>
                                {recepint
                                  ? recepint.name
                                  : get(issueCOList, "recipientGroup")}
                              </span>
                            </p>

                            {get(issueCOList, "forumName", null) ? (
                              <p className="issue-place">
                                Forum -{" "}
                                <span>
                                  {get(issueCOList, "forumName", null)}
                                </span>
                              </p>
                            ) : (
                              <React.Fragment />
                            )}
                            {get(issueCOList, "dateOfOrder", null) ? (
                              <p className="issue-place">
                                Date of Order -{" "}
                                <span>
                                  {dateFormat(
                                    get(issueCOList, "dateOfOrder", null)
                                  )}
                                </span>
                              </p>
                            ) : (
                              <React.Fragment />
                            )}
                            {district ? (
                              <p className="issue-place">
                                District/Department -{" "}
                                <span>{district.name}</span>
                              </p>
                            ) : (
                              <React.Fragment />
                            )}
                            <b className="issue-title">
                              {issueCategoryObj && issueCategoryObj.name}
                            </b>
                            <p className="issue-info">
                              {get(issueCOList, "issueDescription", null)}
                            </p>
                            {(get(issueCOList, "defaultSelected", null) && (
                              <p className="issue-info">
                                Proponent -{" "}
                                {get(issueCOList, "defaultSelected", null)}
                              </p>
                            )) ||
                              null}
                            <div className="attachment-added">
                              {get(issueCOList, "files", []).map(file => {
                                const extension = file.name.substr(
                                  file.name.lastIndexOf(".") + 1,
                                  file.name.length
                                );
                                const name = file.name.substr(
                                  0,
                                  file.name.lastIndexOf(".") - 1
                                );

                                return (
                                  <div className="project-download-icons">
                                    <div className="download-icons-pdf">
                                      {extension}
                                    </div>
                                    <a
                                      href={file.s3Url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {get(file, "title") || name}
                                    </a>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <React.Fragment />
                        );
                      }
                    )
                  : null}
              </div>
            </div>
          ) : (
            "No Project Information Found!!"
          )}
          {previewData.projectCategoryId ? (
            <div className="submission-btns-wrapper">
              <div className="submission-btns-container">
                {isIIGDraft ? (
                  <>
                    {this.loadModalForVerifiedAction()}
                    <Button
                      className="btn-orange btn-desk"
                      onClick={() => {
                        this.setState({
                          showModalForVerifyingProject: true
                        });
                      }}
                    >
                      VERIFY AND ASSIGN TO PP
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      className="btn-orange btn-desk"
                      onClick={this.openConfirmationAlert}
                    >
                      SUBMIT FOR VERIFICATION
                    </Button>
                    <Button
                      type="button"
                      className="btn-orange btn-mobo btn btn-primary"
                      onClick={this.openConfirmationAlert}
                    >
                      SUBMIT
                    </Button>
                  </>
                )}
                <Link
                  to={{
                    pathname: isEdit
                      ? PATHS.PROJECT_DETAILS
                      : isIIGDraft
                      ? PATHS.IIG_PROJECT_DETAIL
                      : PATHS.CREATE_PROJECT,
                    search:
                      isIIGDraft || isEdit
                        ? `?projectId=${previewData.projectId}`
                        : "",
                    state: {
                      projectId: get(previewData, "id"),
                      makeChangesClicked: true
                    }
                  }}
                >
                  <Button className="btn-blue">MAKE CHANGES</Button>
                </Link>
              </div>
              {/*<p>*/}
              {/*Once your project is verified by the sponsoring ministry, then*/}
              {/*your issue will be moved for consideration.*/}
              {/*</p>*/}
            </div>
          ) : null}
        </Container>
      </div>
    );
  }
}

ProjectPreview.propTypes = {
  history: PropTypes.shape({}),
  location: PropTypes.shape({})
};

ProjectPreview.defaultProps = {
  history: {},
  location: {}
};

function mapStateToProps(state) {
  return {
    issuesCategoryList: state.commonReducer.issuesCategoryList,
    pageDetail: state.createProjectReducer.pageDetail,
    previewData: state.formReducer.previewData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createProjectDispatch: createProjectAction,
      clearProjectDataDispatch: clearProjectDataAction,
      editProjectDispatch: editProjectAction
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProjectPreview)
);
